import React, { useContext, useEffect, useState } from 'react';
import { proveedoresApi } from '../api/casosApi';
import UserContext from './user-context';

const ProveedorFilterContext = React.createContext({
  selectedProveedor: null,
  setSelectedProveedor: () => {},
  proveedores: []
});

const ProveedorFilterProvider = ({ children }) => {
  const [selectedProveedor, setSelectedProveedor] = useState(null);
  const [proveedores, setProveedores] = useState([]);
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!user) return;
    proveedoresApi
      .getAll()
      .then(setProveedores)
      .catch(() => {});
  }, [user]);

  return (
    <ProveedorFilterContext.Provider
      value={{ selectedProveedor, setSelectedProveedor, proveedores }}
    >
      {children}
    </ProveedorFilterContext.Provider>
  );
};

export default ProveedorFilterContext;
export { ProveedorFilterProvider };
